import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminBlogList, AdminBlogForm } from "@/pages/admin/AdminBlog";
import { AdminAlumniList, AdminAlumniForm } from "@/pages/admin/AdminAlumni";
import { AdminTestimonialsList, AdminTestimonialsForm } from "@/pages/admin/AdminTestimonials";
import { AdminCatsList, AdminCatsForm } from "@/pages/admin/AdminCats";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminSettings from "@/pages/admin/AdminSettings";
import { AdminContacts, AdminWaitlist } from "@/pages/admin/AdminMessages";

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <div className="min-h-screen bg-cream flex items-center justify-center"><p className="text-forest/60">Chargement...</p></div>;
  return isAuthenticated ? children : <Navigate to="/admin" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute><AdminBlogList /></ProtectedRoute>} />
            <Route path="/admin/blog/new" element={<ProtectedRoute><AdminBlogForm /></ProtectedRoute>} />
            <Route path="/admin/blog/edit/:id" element={<ProtectedRoute><AdminBlogForm /></ProtectedRoute>} />
            <Route path="/admin/alumni" element={<ProtectedRoute><AdminAlumniList /></ProtectedRoute>} />
            <Route path="/admin/alumni/new" element={<ProtectedRoute><AdminAlumniForm /></ProtectedRoute>} />
            <Route path="/admin/alumni/edit/:id" element={<ProtectedRoute><AdminAlumniForm /></ProtectedRoute>} />
            <Route path="/admin/testimonials" element={<ProtectedRoute><AdminTestimonialsList /></ProtectedRoute>} />
            <Route path="/admin/testimonials/new" element={<ProtectedRoute><AdminTestimonialsForm /></ProtectedRoute>} />
            <Route path="/admin/testimonials/edit/:id" element={<ProtectedRoute><AdminTestimonialsForm /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/cats" element={<ProtectedRoute><AdminCatsList /></ProtectedRoute>} />
            <Route path="/admin/cats/new" element={<ProtectedRoute><AdminCatsForm /></ProtectedRoute>} />
            <Route path="/admin/cats/edit/:id" element={<ProtectedRoute><AdminCatsForm /></ProtectedRoute>} />
            <Route path="/admin/gallery" element={<ProtectedRoute><AdminGallery /></ProtectedRoute>} />
            <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
            <Route path="/admin/waitlist" element={<ProtectedRoute><AdminWaitlist /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
